import { trackDigitalEvent } from '@sparknz/tracking';

import { DeviceGalleryQuery } from '__generated__/DeviceGalleryQuery.graphql';
import { buildTrackingProductData } from 'shared/components/ProductGalleryCard/utils/buildTrackingProductData.utils';
import { Channel, Segment } from 'shared/hooks';

interface TrackOpenProductDetailsProps {
  product: DeviceGalleryQuery['response']['deviceGallery']['products'][0];
  channel: Channel;
  segment: Segment;
}

export function trackOpenProductDetails({
  product,
  channel,
  segment,
}: TrackOpenProductDetailsProps) {
  trackDigitalEvent({
    event: 'shop.openProductDetails',
    w3cddl: {
      event: [
        {
          eventInfo: {
            eventName: 'Shop Open Product Details',
            eventAction: 'shop.openProductDetails',
          },
        },
      ],

      product: buildTrackingProductData({
        product,
        channel,
        segment,
      }),
    },
  });
}
